// extracted by mini-css-extract-plugin
export default {"title":"quick-charge-method-modal_title__20-+f","options":"quick-charge-method-modal_options__0f91j","option":"quick-charge-method-modal_option__gDdLj"};